import React, { useMemo } from "react";
import { NavLink } from "react-router-dom";
import navBarData from "../../Routes/navBarData";
import { User, ChevronLeft } from "lucide-react";

export default function   Sidebar({ sidebarOpen, setSidebarOpen }) {
  const authUserString = localStorage.getItem("authUserData");
  const authUser = authUserString ? JSON.parse(authUserString) : null;

  const LoginUserName = authUser?.name || authUser?.business_name || (`${authUser.first_name} ${authUser.last_name}`);
  const loginUserCode = authUser?.org_code;
  const userRole = authUser?.role;
  const typeOfUser = authUser?.type_of_user;
  const position = authUser?.position;

  const filteredMenu = useMemo(() => {
  let menu = navBarData
  .filter((item) => !item.roles || item.roles.includes(userRole))
  .map((item) => {
    /* ---------------- ROLE 3 LOGIC ---------------- */
    if (userRole === 3) {
      // Operation user → oprdash as Dashboard
      if (typeOfUser === "Operation") {
        if (item.id === "oprdash") {
          return { ...item, label: "Dashboard" };
        }
        if (item.id === "empdash") {
          return null; // 🚫 completely hide Leads
        }
      }

      // Non-operation employee → empdash as Dashboard
      if (typeOfUser !== "Operation") {
        if (item.id === "empdash") {
          return { ...item, label: "Dashboard" };
        }

        // ❌ Hide Assign Retailers for Sales
        if (item.id === "oprdash" && typeOfUser === "Sales") {
          return null;
        }

        if (item.id === "oprdash") {
          return { ...item, label: "Assign Retailers" };
        }
      }

    }

    /* ---------------- DEFAULT empdash LABEL ---------------- */
    if (item.id === "empdash") {
      return {
        ...item,
        label: userRole === 3 ? "Dashboard" : "Leads",
      };
    }
    if (
      item.id === "teammember" &&
      userRole === 3 &&
      position === "EXECUTIVE"
    ) {
      return null;
    }

    return item;
  })
  .filter(Boolean);


  /* ---------------- ROLE 3 PRIORITY ---------------- */
  if (userRole === 3) {
    const priorityOrder =
      typeOfUser === "Operation"
        ? ["oprdash", "agentdashboard"]   // 🔥 Operation first
        : ["empdash", "agentdashboard"];  // 🔥 Normal employee first

    menu.sort((a, b) => {
      const indexA = priorityOrder.indexOf(a.id);
      const indexB = priorityOrder.indexOf(b.id);

      if (indexA === -1 && indexB === -1) return 0;
      if (indexA === -1) return 1;
      if (indexB === -1) return -1;
      return indexA - indexB;
    });
  }


  /* ---------------- ROLE 6 PRIORITY ---------------- */
  if (userRole === 6) {
    const dashboardIndex = menu.findIndex(
      (item) => item.id === "userdashboard"
    );

    if (dashboardIndex > 0) {
      const [dashboardItem] = menu.splice(dashboardIndex, 1);
      menu.unshift(dashboardItem); // 🔥 move to top
    }
  }

  /* ---------------- OTHER ROLES ---------------- */
  if (userRole !== 3 && userRole !== 6) {
    const dashboardIndex = menu.findIndex(
      (item) => item.id.includes("dashboard") && item.id !== "empdash"
    );
    const empdashIndex = menu.findIndex((item) => item.id === "empdash");

    if (dashboardIndex !== -1 && empdashIndex !== -1) {
      const [empdashItem] = menu.splice(empdashIndex, 1);
      menu.splice(dashboardIndex + 3, 0, empdashItem);
    }
  }

  return menu;
}, [userRole]);


  const roleDisplayName = {
    1: "Admin",
    2: "Company",
    3: "Employee",
    4: "Agent",
    5: "Retailer",
    6: "User",
    7: "Customer",
  };

  return (
    // <aside
    //   className={`fixed inset-y-0 left-0 bg-white border-r border-slate-200 transition-all duration-300
    //   md:relative md:z-auto z-50
    //   ${sidebarOpen ? "w-50" : "w-50"}`}
    // >

    <aside
  className={`
    h-full bg-white border-r border-slate-200
    transition-all duration-300
    ${sidebarOpen ? "block" : "hidden"}
  `}
>

      {sidebarOpen && (
        <>
          {/* Close Button */}
          <button
            onClick={() => setSidebarOpen(false)}
            className="absolute right-1 top-1 bg-white shadow-md w-8 h-8 flex items-center justify-center rounded-full border hover:bg-blue-50"
          >
            <ChevronLeft size={18} />
          </button>

          {/* User Section */}
        <div className="flex items-center gap-3 p-4 border-b border-slate-100 bg-gray-50 rounded-b-xl">
            {/* Avatar */}
            {/* <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-blue-600 text-white text-lg font-bold shadow">
              {LoginUserName?.charAt(0)}
            </div> */}

            {/* Name and Code */}
            <div className="flex flex-col min-w-0">
              <div className="flex items-center gap-2">
                <User className="w-4 h-4 text-blue-600 flex-shrink-0" />
                <span className="text-base font-semibold break-words">
                  {LoginUserName}
                </span>
              </div>
              {loginUserCode && (
                <p className="text-xs text-slate-500 break-words">{loginUserCode}</p>
              )}
            </div>
          </div>



          {/* Menu List */}
          <nav className="px-3 py-4 space-y-1 text-sm">
            {filteredMenu.map((item) => (
              <NavLink
                key={item.id}
                to={item.path}
                onClick={() => {
                  if (window.innerWidth < 640) {
                    setSidebarOpen(false);
                  }
                }}
              >

                {({ isActive }) => (
                  <div
                    className={`flex items-center gap-3 px-3 py-2 rounded-xl font-medium transition ${
                      isActive ? "bg-blue-600 text-white shadow-sm" : "text-slate-700 hover:bg-blue-50"
                    }`}
                  >
                    {item.icon && (
                      <item.icon
                        className={`w-4 h-4 ${isActive ? "text-white" : "text-blue-700"}`}
                        strokeWidth={2.3}
                      />
                    )}
                    <span>{item.label}</span>
                  </div>
                )}
              </NavLink>
            ))}
          </nav>

          {/* Footer */}
          <div className="px-4 py-4 border-t border-slate-100 text-xs text-slate-500">
            Logged in as:{" "}
            <span className="font-semibold">{userRole === 3
              ? `${roleDisplayName[userRole]} (${authUser?.type_of_user || "Employee"} ${authUser?.position || "-"})`
              : roleDisplayName[userRole] ?? userRole}</span>
          </div>
        </>
      )}
    </aside>
  );
}



// import React, { useMemo } from "react";
// import { NavLink } from "react-router-dom";
// import navBarData from "../../Routes/navBarData";
// import { User, ChevronLeft } from "lucide-react";

// export default function Sidebar({ sidebarOpen, setSidebarOpen }) {
//   const authUserString = localStorage.getItem("authUserData");
//   const authUser = authUserString ? JSON.parse(authUserString) : null;

//   const LoginUserName = authUser?.name || authUser?.business_name;
//   const loginUserCode = authUser?.org_code;
//   const userRole = authUser?.role; // numeric role: 1,2,3...

//   const filteredMenu = useMemo(() => {
//     return navBarData.filter((item) => !item.roles || item.roles.includes(userRole));
//   }, [userRole]);

//   const roleDisplayName = {
//     1: "Admin",
//     2: "Company",
//     3: "Employee",
//     4: "Agent",
//     5: "Retailer",
//     6: "User",
//     7: "Customer",
//   };

//   return (
//     <aside
//       className={`fixed inset-y-0 left-0 bg-white border-r border-slate-200 transition-all duration-300
//         md:relative md:z-auto z-50
//         ${sidebarOpen ? "w-50" : "w-0"}`}
//     >
//       {sidebarOpen && (
//         <>
//           {/* Close Button */}
//           <button
//             onClick={() => setSidebarOpen(false)}
//             className="absolute right-4 top-3 bg-white shadow-md w-8 h-8 flex items-center justify-center rounded-full border hover:bg-blue-50"
//           >
//             <ChevronLeft size={18} />
//           </button>

//           {/* User Section */}
//           <div className="flex items-center gap-3 p-3 border-b border-slate-100">
//             <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-blue-600 text-white text-lg font-bold">
//               {LoginUserName?.charAt(0)}
//             </div>
//             <div>
//               <p className="text-base font-semibold flex items-center gap-2">
//                 <User className="w-4 h-4 text-blue-600" />
//                 {LoginUserName}
//               </p>
//               {loginUserCode && <p className="text-xs text-slate-500">{loginUserCode}</p>}
//             </div>
//           </div>

//           {/* Menu */}
//           <nav className="px-3 py-4 space-y-1 text-sm">
//             {filteredMenu.map((item) => (
//               <NavLink key={item.id} to={item.path}>
//                 {({ isActive }) => (
//                   <div
//                     className={`flex items-center gap-3 px-3 py-2 rounded-xl font-medium transition ${
//                       isActive ? "bg-blue-600 text-white shadow-sm" : "text-slate-700 hover:bg-blue-50"
//                     }`}
//                   >
//                     {item.icon && (
//                       <item.icon
//                         className={`w-4 h-4 ${isActive ? "text-white" : "text-blue-700"}`}
//                         strokeWidth={2.3}
//                       />
//                     )}
//                     <span>{item.label}</span>
//                   </div>
//                 )}
//               </NavLink>
//             ))}
//           </nav>

//           {/* Footer */}
//           <div className="px-4 py-4 border-t border-slate-100 text-xs text-slate-500">
//             Logged in as:{" "}
//             <span className="font-semibold">{roleDisplayName[userRole] ?? userRole}</span>
//           </div>
//         </>
//       )}
//     </aside>
//   );
// }





// import React, { useMemo } from "react";
// import { NavLink } from "react-router-dom";
// import navBarData from "../../Routes/navBarData";
// import { User, ChevronLeft } from "lucide-react";

// export default function Sidebar({ sidebarOpen, setSidebarOpen }) {
//   const authUserString = localStorage.getItem("authUserData");
//   const authUser = authUserString ? JSON.parse(authUserString) : null;

//   const LoginUserName = authUser?.name || authUser?.business_name;
//   const loginUserCode = authUser?.org_code;
//   const userRole = authUser?.type;

//   const filteredMenu = useMemo(() => {
//     return navBarData.filter((item) => !item.roles || item.roles.includes(userRole));
//   }, [userRole]);

//   const roleDisplayName = {
//     admin: "Admin",
//     superadmin: "Super Admin",
//     agent: "Agent",
//     company: "Company",
//     distributor: "Distributor",
//     retailer: "Retailer",
//     user: "User",
//     customer: "Customer",
//   };

//   return (
//     <aside
//       className={`fixed inset-y-0 left-0 bg-white border-r border-slate-200 transition-all duration-300
//         md:relative md:z-auto z-50
//         ${sidebarOpen ? "w-64" : "w-0"}`}
//     >
//       {sidebarOpen && (
//         <>
//           {/* Close Button */}
//           <button
//             onClick={() => setSidebarOpen(false)}
//             className="absolute right-4 top-3 bg-white shadow-md w-8 h-8 flex items-center justify-center rounded-full border hover:bg-blue-50"
//           >
//             <ChevronLeft size={18} />
//           </button>

//           {/* User Section */}
//           <div className="flex items-center gap-3 p-3 border-b border-slate-100">
//             <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-blue-600 text-white text-lg font-bold">
//               {LoginUserName?.charAt(0)}
//             </div>

//             <div>
//               <p className="text-base font-semibold flex items-center gap-2">
//                 <User className="w-4 h-4 text-blue-600" />
//                 {LoginUserName}
//               </p>
//               {loginUserCode && <p className="text-xs text-slate-500">{loginUserCode}</p>}
//             </div>
//           </div>

//           {/* Menu */}
//           <nav className="px-3 py-4 space-y-1 text-sm">
//             {filteredMenu.map((item) => (
//               <NavLink key={item.id} to={item.path}>
//                 {({ isActive }) => (
//                   <div
//                     className={`flex items-center gap-3 px-3 py-2 rounded-xl font-medium transition ${
//                       isActive ? "bg-blue-600 text-white shadow-sm" : "text-slate-700 hover:bg-blue-50"
//                     }`}
//                   >
//                     {item.icon && (
//                       <item.icon
//                         className={`w-4 h-4 ${isActive ? "text-white" : "text-blue-700"}`}
//                         strokeWidth={2.3}
//                       />
//                     )}
//                     <span>{item.label}</span>
//                   </div>
//                 )}
//               </NavLink>
//             ))}
//           </nav>

//           {/* Footer */}
//           <div className="px-4 py-4 border-t border-slate-100 text-xs text-slate-500">
//             Logged in as:{" "}
//             <span className="font-semibold">{roleDisplayName[userRole] ?? userRole}</span>
//           </div>
//         </>
//       )}
//     </aside>
//   );
// }




// import React, { useMemo } from "react";
// import { NavLink } from "react-router-dom";
// import navBarData from "../../Routes/navBarData";
// import { User } from "lucide-react";

// export default function Sidebar({ sidebarOpen }) {
//   const authUserString = localStorage.getItem("authUserData");
//   const authUser = authUserString ? JSON.parse(authUserString) : null;

//   const LoginUserName = authUser?.name || authUser?.business_name;
//   const loginUserCode = authUser?.org_code;
//   const userRole = authUser?.type; // e.g., "admin", "company", "retailer"

//   // Filter menu items by role
//   const filteredMenu = useMemo(() => {
//     return navBarData.filter((item) => !item.roles || item.roles.includes(userRole));
//   }, [userRole]);

//   const roleDisplayName = {
//     admin: "Admin",
//     superadmin: "Super Admin",
//     agent: "Agent",
//     company: "Company",
//     distributor: "Distributor",
//     retailer: "Retailer",
//     user: "User",
//     customer: "Customer",
//   };

//   return (
//     <aside
//       className={`
//         fixed inset-y-0 left-0 w-64 bg-white border-r border-slate-200
//         transition-transform duration-300
//         ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}
//         md:translate-x-0 md:relative
//         z-50 md:z-auto
//       `}
//     >
//       {/* User Box */}
//       <div className="flex gap-3 p-3 border-b border-slate-100">
//         <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-blue-600 text-white text-lg font-bold">
//           {LoginUserName?.charAt(0)}
//         </div>
//         <div>
//           <p className="text-base font-semibold flex items-center gap-2">
//             <User className="w-4 h-4 text-blue-600" />
//             {LoginUserName}
//           </p>
//           {loginUserCode && <p className="text-xs text-slate-500">{loginUserCode}</p>}
//         </div>
//       </div>

//       {/* Navigation */}
//       <nav className="grid px-3 py-4 space-y-1 text-sm">
//         {filteredMenu.map((item) => (
//           <NavLink key={item.id} to={item.path}>
//             {({ isActive }) => (
//               <div
//                 className={`flex items-center gap-3 px-3 py-2 rounded-xl font-medium transition ${
//                   isActive ? "bg-blue-600 text-white shadow-sm" : "text-slate-700 hover:bg-blue-50"
//                 }`}
//               >
//                 {item.icon && (
//                   <item.icon
//                     className={`w-5 h-5 transition ${isActive ? "text-white" : "text-blue-700"}`}
//                     strokeWidth={2.5}
//                   />
//                 )}
//                 <span>{item.label}</span>
//               </div>
//             )}
//           </NavLink>
//         ))}
//       </nav>

//       {/* Footer */}
//       <div className="px-4 py-4 border-t border-slate-100 text-xs text-slate-500">
//         Logged in as:{" "}
//         <span className="font-semibold">{roleDisplayName[userRole] ?? userRole}</span>
//       </div>
//     </aside>
//   );
// }


// import React from "react";
// import { NavLink } from "react-router-dom";
// import navBarData from "../../Routes/navBarData";
// import { User } from "lucide-react";

// export default function Sidebar({ sidebarOpen }) {
//   const authUserString = localStorage.getItem("authUserData");
//   const authUser = authUserString ? JSON.parse(authUserString) : null;

//   const LoginUserName = authUser?.name || authUser?.business_name;
//   const loginUserCode = authUser?.org_code;
//   const userRole = authUser?.type; // "admin", "company", etc.

//   // FINAL FILTER LOGIC (supports role & roles)
//   const filteredMenu = navBarData.filter((item) => {
//     // If no role restriction, show it
//     if (!item.role && !item.roles) return true;

//     // If single role is set
//     if (item.role && item.role === userRole) return true;

//     // If multiple allowed roles exist
//     if (Array.isArray(item.roles) && item.roles.includes(userRole)) return true;

//     return false;
//   });

//   const roleDisplayName = {
//     admin: "Admin",
//     superadmin: "Super Admin",
//     agent: "Agent",
//     company: "Company",
//     distributor: "Distributor",
//     retailer: "Retailer",
//     user: "User",
//   };

//   return (
//     <aside
//       className={`
//         fixed inset-y-0 left-0 w-64 bg-white border-r border-slate-200
//         transition-transform duration-300
//         ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}
//         md:translate-x-0 md:relative
//         z-50 md:z-auto
//       `}
//     >
//       {/* User Box */}
//       <div className="flex gap-3 p-3 border-b border-slate-100">
//         <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-blue-600 text-white text-lg font-bold">
//           {LoginUserName?.charAt(0)}
//         </div>

//         <div>
//           <p className="text-base font-semibold flex items-center gap-2">
//             <User className="w-4 h-4 text-blue-600" />
//             {LoginUserName}
//           </p>
//           {loginUserCode && (
//             <p className="text-xs text-slate-500">{loginUserCode}</p>
//           )}
//         </div>
//       </div>

//       {/* Navigation */}
//       <nav className="grid px-3 py-4 space-y-1 text-sm">
//         {filteredMenu.map((item) => (
//           <NavLink key={item.id} to={item.path}>
//             {({ isActive }) => (
//               <div
//                 className={`flex items-center gap-3 px-3 py-2 rounded-xl font-medium transition ${
//                   isActive
//                     ? "bg-blue-600 text-white shadow-sm"
//                     : "text-slate-700 hover:bg-blue-50"
//                 }`}
//               >
//                 {item.icon && (
//                   <item.icon
//                     className={`w-5 h-5 transition ${
//                       isActive ? "text-white" : "text-blue-700"
//                     }`}
//                     strokeWidth={2.5}
//                   />
//                 )}
//                 <span>{item.label}</span>
//               </div>
//             )}
//           </NavLink>
//         ))}
//       </nav>

//       {/* Footer */}
//       <div className="px-4 py-4 border-t border-slate-100 text-xs text-slate-500">
//         Logged in as:{" "}
//         <span className="font-semibold">{roleDisplayName[userRole] ?? userRole}</span>
//       </div>
//     </aside>
//   );
// }



// import React from "react";
// import { NavLink } from "react-router-dom";
// import navBarData from "../../Routes/navBarData";
// import { User } from "lucide-react";

// export default function Sidebar({ sidebarOpen }) {
//   const authUserString = localStorage.getItem("authUserData");
//   const authUser = authUserString ? JSON.parse(authUserString) : null;

//   const LoginUserName = authUser?.business_name;
//   const loginUserCode = authUser?.org_code;

//   return (
//     <aside
//       className={`
//         fixed inset-y-0 left-0 w-64 bg-white border-r border-slate-200
//         transition-transform duration-300
//         ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}
//         md:translate-x-0 md:relative
//         z-50 md:z-auto
//       `}
//     >
//       {/* Top User Section */}
//       <div className="flex gap-3 p-3 border-b border-slate-100">
//         <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-blue-600 text-white text-lg font-bold">
//           {LoginUserName?.charAt(0)}
//         </div>

//         <div>
//           <p className="text-base font-semibold flex items-center gap-2">
//             <User className="w-4 h-4 text-blue-600" />
//             {LoginUserName}
//           </p>
//           <p className="text-xs text-slate-500">{loginUserCode}</p>
//         </div>
//       </div>

//       {/* Navigation */}
//       <nav className="grid px-3 py-4 space-y-1 text-sm">
//         {navBarData.map((item) => (
//           <NavLink key={item.id} to={item.path}>
//             {({ isActive }) => (
//               <div
//                 className={`flex items-center gap-3 px-3 py-2 rounded-xl font-medium transition ${
//                   isActive
//                     ? "bg-blue-600 text-white shadow-sm"
//                     : "text-slate-700 hover:bg-blue-50"
//                 }`}
//               >
//                 {/* ICON */}
//                 {item.icon && (
//                   <item.icon
//                     className={`w-5 h-5 transition ${
//                       isActive ? "text-white" : "text-blue-700"
//                     }`}
//                     strokeWidth={2.5}
//                   />
//                 )}

//                 {/* LABEL */}
//                 <span>{item.label}</span>
//               </div>
//             )}
//           </NavLink>
//         ))}
//       </nav>

//       <div className="px-4 py-4 border-t border-slate-100 text-xs text-slate-500">
//         Logged in as <span className="font-semibold">Agent</span>
//       </div>
//     </aside>
//   );
// }
 



// import React from "react";
// import { NavLink, useLocation } from "react-router-dom";
// import navBarData from "../../Routes/navBarData";
// import ContentHeader from "./ContentHeader";
// import { User } from "lucide-react";
// import { formatDateTime } from "./formatDateTime";


// export default function Sidebar({sidebarOpen}) {

//    const authUserString = localStorage.getItem("authUserData");
//   const authUser = JSON.parse(authUserString);
//   const LoginUserName = authUser?.business_name;
//   const loginUserCode = authUser?.org_code;
//   const loginUserCreated = authUser?.created_at;
//   return (
//     <aside
//     className={`
//         fixed inset-y-0 left-0 w-64 bg-white border-r border-slate-200
//         transition-transform duration-300
//         ${sidebarOpen ? "translate-x-0" : "-translate-x-full"} 
//         md:translate-x-0 md:relative

//         z-50 md:z-auto   // <-- ADD THIS
//     `}
//     >

      
//     <div className="flex gap-3 p-2">
//       <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-blue-600 text-white text-lg font-bold">
//           {LoginUserName?.charAt(0)}
//         </div>

//         <div>
//           <p className="text-base font-semibold flex items-center gap-2">
//             <User  className="w-4 h-4 text-blue-600" />
//             {LoginUserName}
//           </p>
//           <p className="text-xs text-slate-500">
//             {loginUserCode} 
//           </p>
//         </div>
//     </div>
       

//       <nav className="grid grid-row px-2 py-4 space-y-1 text-sm">
//         {navBarData.map((item) => (
//           <NavLink
//             key={item.id}
//             to={item.path}
//             className={({ isActive }) =>
//               `w-full text-left px-3 py-2 rounded-xl font-medium ${
//                 isActive
//                   ? "bg-blue-600 text-white shadow-sm"
//                   : "text-slate-700 hover:bg-blue-50"
//               }`
//             }
//           >
//             {item.icon} {item.label}
//           </NavLink>
//         ))}
//       </nav>

//       <div className="px-4 py-4 border-t border-slate-100 text-xs text-slate-500">
//         Logged in as <span className="font-semibold">Agent</span>
//       </div>
//     </aside>
//   );
// }
